class CartDrawer
{
    backgroundOverlay;
    cartDrawer; 
    cartDarawerSubtotal; 
    cartDrawerBodyDomEl;

    constructor() {
        this.backgroundOverlay = document.querySelector('#cart-drawer-bg-overlay');
        this.cartDrawer = document.querySelector('#cart-drawer');
        this.cartDarawerSubtotal = document.querySelector('#basket-drawer-subtotal');
        this.cartDrawerBodyDomEl = document.querySelector('#cart-drawer-body');
        this.setUpEventListenerForProductPageAddToCartButtonPressed();
    }

    open()
    {
        this.cartDrawer.style.display = 'block';
        this.backgroundOverlay.style.display = 'block';
        // lock main body scroll
        document.documentElement.style.overflow = 'hidden';
        document.dispatchEvent(new Event("cart_drawer_openned"));
    }

    close()
    {
        this.cartDrawer.style.display = 'none';
        this.backgroundOverlay.style.display = 'none';
        // unlock main body scroll
        document.documentElement.style.overflow = 'auto';
        document.dispatchEvent(new Event("cart_drawer_closed"));
    }

    populateCart() {
        this.populateCartSubtotal();
        this.populateCartItems();
    }

    populateCartSubtotal()
    {
        const context = this;

        this.fetchCartData((data) => {
            context.cartDarawerSubtotal.innerHTML = (data['items_subtotal_price'] / 100).toFixed(2)
        });
    }

    populateCartItems()
    {
        const context = this;

        this.fetchCartItems((cartPageDocString) => {
            const parser = new DOMParser();
            const cartPageDoc = parser.parseFromString(cartPageDocString, 'text/html');
            const cartHtml = cartPageDoc.querySelector('#content_for_cart_drawer');
            context.cartDrawerBodyDomEl.innerHTML = cartHtml.innerHTML;

            // set up qty drop downs
            context.setUpQtyDropDowns();
            // set up delete buttons
            context.setUpDeleteBtns();
        });
    }

    setUpQtyDropDowns()
    {
        const qtySelectors = document.querySelectorAll(".cart-qty-selector");

        qtySelectors.forEach(select => {
            select.addEventListener("change", function () {
            const line = this.dataset.line;
            const quantity = this.value;

            fetch(`/cart/change.js`, {
                method: "POST",
                headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
                },
                body: JSON.stringify({
                line: line,
                quantity: quantity
                })
            })
            .then(res => res.json())
            .then(cart => {
                // reload cart
                document.dispatchEvent(new Event("cart_drawer_openned"));
            })
            .catch(err => console.error("Cart update failed", err));
            });
        });
    }

    setUpDeleteBtns()
    {
         const deleteButtons = document.querySelectorAll(".basket-item-delete-btn");

        deleteButtons.forEach(button => {
            button.addEventListener("click", function (e) {
            e.preventDefault();

            const line = this.dataset.line;

            fetch(`/cart/change.js`, {
                method: "POST",
                headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
                },
                body: JSON.stringify({
                line: line,
                quantity: 0
                })
            })
            .then(res => res.json())
            .then(cart => {
                  // reload cart
                document.dispatchEvent(new Event("cart_drawer_openned"));
            })
            .catch(err => console.error("Delete failed", err));
            });
        });
    }

    fetchCartData(callback)
    {
        fetch('/cart.js')
            .then(response => {
                return response.json();
            })
            .then(data => {
                return callback(data);
            });
    }

    fetchCartItems(callback)
    {
        fetch('/cart?view=drawer')
            .then(response => {
                return response.text();
            })
            .then(data => {
                return callback(data);
            });
    }

    setUpEventListenerForProductPageAddToCartButtonPressed()
{
    const addToCartFormOnProductPage = document.querySelector('form[action="/cart/add"]');

    if (!addToCartFormOnProductPage) {
        return;
    }

    if (addToCartFormOnProductPage.dataset.cartDrawerBound === 'true') {
        return;
    }

    addToCartFormOnProductPage.dataset.cartDrawerBound = 'true';

    let isSubmitting = false;

    const handleSubmit = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        if (isSubmitting) {
            return;
        }

        isSubmitting = true;

        try {
            const form = e.currentTarget;
            const formData = new FormData(form);

            const res = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                    'Accept': 'application/json'
                },
                body: formData
            });

            if (!res.ok) {
                throw new Error('Failed to add item to cart');
            }

            const item = await res.json();

            document.dispatchEvent(new CustomEvent('cart:item-added', {
                detail: item
            }));

            this.populateCart();
            this.open();
        } catch (error) {
            console.error('Add to cart failed', error);
        } finally {
            setTimeout(() => {
                isSubmitting = false;
            }, 500);
        }
    };

    addToCartFormOnProductPage.addEventListener('submit', handleSubmit, true);
}
}